import actionTypes from '../actionTypes';
import {
	transformSummary,
	transformChartData,
} from '../../common/wrapperComponents/ComparisonChartWrapper/transform';
import { menuListOptions } from '../../common/wrapperComponents/ComparisonChartWrapper/constants';
export const initialState = {
	isLoadingA: true,
	isErrorA: false,
	isSuccessA: false,
	isLoadingB: false,
	isErrorB: false,
	isSuccessB: false,
	chartDataA: [],
	chartDataB: [],
	granularity: 'WEEK',
	metricA: 'Net Sales',
	metricB: '',
	summaryValueA: null,
	summaryPctValueA: null,
	summaryValueB: null,
	summaryPctValueB: null,
	timePeriod: 'Weekly',
	primaryOptionList: menuListOptions['OMNI'],
	comparisonOptionList: menuListOptions['OMNI']
};

const chartComparisonReducer = (state = initialState, action = {}) => {
	switch (action?.type) {
		case actionTypes.SET_GRANULARITY: {
			return {
				...state,
				granularity: action?.payload?.granularity,
			};
		}
		case actionTypes.SET_METRIC_A: {
			return {
				...state,
				metricA: action?.payload?.metricA
			};
		}
		case actionTypes.SET_METRIC_B: {
			return {
				...state,
				metricB: action?.payload?.metricB
			};
		}
		case actionTypes.SET_CHART_DATA_A: {
			return {
				...state,
				chartDataA: transformChartData(action?.payload?.chartData),
				summaryPctValueA: transformSummary(action?.payload?.summary)
					.summaryPctValue,
				summaryValueA: transformSummary(action?.payload?.summary).summaryValue,
				isLoadingA: false
			};
		}

		case actionTypes.SET_CHART_DATA_B: {
			return {
				...state,
				chartDataB: transformChartData(action?.payload?.chartData),
				summaryPctValueB: transformSummary(action?.payload?.summary)
					.summaryPctValue,
				summaryValueB: transformSummary(action?.payload?.summary).summaryValue,
				isLoadingB: false
			};
		}

		case actionTypes.CLEAR_METRIC_A: {
			return {
				...state,
				chartDataA: [],
				summaryValueA: null,
				summaryPctValueA: null,
				isSuccessA: false,
				isErrorA: false,
				isLoadingA: false,
			};
		}
		case actionTypes.CLEAR_METRIC_B: {
			return {
				...state,
				chartDataB: [],
				summaryValueB: null,
				summaryPctValueB: null,
				isSuccessB: false,
				isErrorB: false,
				isLoadingB: false,
			};
		}

		case actionTypes.SET_METRIC_A_ERROR_STATUS: {
			return {
				...state,
				isErrorA: true,
				isLoadingA: false,
				chartDataA: [],
				summaryValueA: null,
				summaryPctValueA: null,
			};
		}

		case actionTypes.SET_METRIC_B_ERROR_STATUS: {
			return {
				...state,
				isErrorB: true,
				isLoadingB: false,
				chartDataB: [],
				summaryValueB: null,
				summaryPctValueB: null,
			};
		}

		case actionTypes.SET_COMPARISON_CHART_TIME_PERIOD: {
			return {
				...state,
				timePeriod: action?.payload?.timePeriod,
			};
		}

		case actionTypes.SET_METRIC_A_LOADING_STATUS: {
			return {
				...state,
				isLoadingA: action?.payload
			}
		}

		case actionTypes.SET_METRIC_B_LOADING_STATUS: {
			return {
				...state,
				isLoadingB: action?.payload
			}
		}

		case actionTypes.SET_PRIMARY_OPTION_LIST: {
			return {
				...state,
				primaryOptionList: action?.payload
			}	
		}

		case actionTypes.SET_COMPARISON_OPTION_LIST: {
			return {
				...state,
				comparisonOptionList: action?.payload
			}	
		}

		default:
			return state;
	}
};

export default chartComparisonReducer;
